import cn from 'clsx'
import { useScrollTop } from '@hooks'
import { ScrollTopButton } from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp'

const ScrollToTop = ({ className, ...props }) => {
  const stick = useScrollTop()
  const onClickHandler = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (stick) {
    return (
      <ScrollTopButton
        type="button"
        className={cn(className, 'scroll-to-top')}
        onClick={onClickHandler}
        isStick
        {...props}
      >
        <span className="icon arrow-up">
          <FontAwesomeIcon icon={faArrowUp} />
        </span>
        <span className="icon arrow-bottom">
          <FontAwesomeIcon icon={faArrowUp} />
        </span>
      </ScrollTopButton>
    )
  } else {
    return null
  }
}

export default ScrollToTop
